import script from "./partial-allowedaction-button-dialog-wrapper.vue?vue&type=script&lang=ts"
export * from "./partial-allowedaction-button-dialog-wrapper.vue?vue&type=script&lang=ts"

import "./partial-allowedaction-button-dialog-wrapper.vue?vue&type=style&index=0&id=4bebde44&lang=css"

const __exports__ = script;

export default __exports__